<nb-card class="exercise-import-dialog">
  <nb-card-header>
    <h5>{{ "pages.dozent.exerciseImport.title" | translate }}</h5>
  </nb-card-header>

  <nb-card-body>
    <!-- Phase 1: file selection -->
    <ng-container *ngIf="phase === 'select'">
      <p class="dialog-hint">
        {{ "pages.dozent.exerciseImport.hint" | translate }}
      </p>

      <label
        class="file-drop"
        [class.drag-over]="dragOver"
        for="exercise-import-input"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onFilesDropped($event)"
      >
        <nb-icon icon="cloud-upload-outline"></nb-icon>
        <span>{{ "pages.dozent.exerciseImport.choose" | translate }}</span>
        <span class="drop-hint">{{ "pages.dozent.exerciseImport.dropHint" | translate }}</span>
        <input
          id="exercise-import-input"
          type="file"
          multiple
          accept=".pdf,.txt,.docx,.csv,application/pdf,text/plain,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/csv"
          (change)="onFilesSelected($event)"
        />
      </label>

      <p class="error-text" *ngIf="fileError">{{ fileError }}</p>
      <p class="error-text" *ngIf="uploadError">{{ uploadError }}</p>
      <p class="error-text" *ngIf="quotaExhausted">
        {{ "pages.dozent.exerciseImport.errors.quotaExhausted" | translate }}
      </p>

      <ul class="file-list" *ngIf="selectedFiles.length">
        <li *ngFor="let file of selectedFiles; let i = index">
          <nb-icon icon="file-text-outline"></nb-icon>
          <span class="file-name">{{ file.name }}</span>
          <button
            nbButton
            ghost
            size="tiny"
            status="danger"
            (click)="removeFile(i)"
            [attr.aria-label]="'buttons.delete' | translate"
          >
            <nb-icon icon="close-outline"></nb-icon>
          </button>
        </li>
      </ul>
    </ng-container>

    <!-- Phase 2/3: progress + summary -->
    <ng-container *ngIf="phase !== 'select'">
      <p class="dialog-hint" *ngIf="processing">
        {{ "pages.dozent.exerciseImport.processingHint" | translate }}
      </p>

      <ul class="job-list">
        <li *ngFor="let job of jobs">
          <span class="job-status">
            <nb-icon
              *ngIf="job.status === 'queued' || job.status === 'processing'"
              icon="loader-outline"
              class="spin"
            ></nb-icon>
            <nb-icon
              *ngIf="job.status === 'done'"
              icon="checkmark-circle-2-outline"
              class="ok"
            ></nb-icon>
            <nb-icon
              *ngIf="job.status === 'error'"
              icon="alert-circle-outline"
              class="err"
            ></nb-icon>
          </span>
          <span class="job-copy">
            <span class="file-name">{{ job.filename }}</span>
            <span class="job-detail" *ngIf="job.status === 'error'">
              {{ errorMessage(job) }}
            </span>
            <span class="job-detail" *ngIf="job.warnings?.length && job.status === 'done'">
              {{ job.warnings.join(" ") }}
            </span>
          </span>
        </li>
      </ul>

      <p class="summary" *ngIf="phase === 'summary'">
        {{
          "pages.dozent.exerciseImport.summary"
            | translate: { success: createdCount, failed: errorCount }
        }}
      </p>
    </ng-container>
  </nb-card-body>

  <nb-card-footer>
    <button nbButton ghost (click)="close()">
      {{
        (phase === "summary"
          ? "buttons.close"
          : phase === "processing"
            ? "pages.dozent.exerciseImport.closeBackground"
            : "buttons.cancel"
        ) | translate
      }}
    </button>
    <button
      *ngIf="phase === 'select'"
      nbButton
      status="primary"
      [disabled]="!selectedFiles.length || quotaExhausted"
      (click)="startImport()"
    >
      <nb-icon icon="upload-outline"></nb-icon>
      {{ "pages.dozent.exerciseImport.start" | translate }}
    </button>
  </nb-card-footer>
</nb-card>
